export default __webpack_public_path__ + "media/projects/yellow2-thumb-095bb5fe.svg";